if (!customElements.get('s-all-brands')) {
  customElements.define(
    's-all-brands',
    class SectionAllBrands extends HTMLElement {
      connectedCallback() {
        this.navigationEl = this.querySelector('.js-all-brands-navigation');
        this.navigationLinks = [...this.querySelectorAll('.js-all-brands-navigation-link')];

        if (!this.navigationEl) return;

        this.navigationEl.addEventListener('click', this.handleNavigationClick);
        this.setActiveLink(window.location.hash);
      }

      disconnectedCallback() {
        this.navigationEl?.removeEventListener('click', this.handleNavigationClick);
      }

      handleNavigationClick = (event) => {
        const link = event.target.closest('.js-all-brands-navigation-link');

        if (!link || !this.navigationEl.contains(link)) return;

        const targetId = link.hash.slice(1);
        const target = document.getElementById(targetId);

        if (!target) return;

        event.preventDefault();
        this.setActiveLink(link.hash);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start',
        });

        window.history.replaceState(null, '', link.hash);
      };

      setActiveLink(hash) {
        const matchingLink = this.navigationLinks.find((link) => link.hash === hash);
        const activeLink = matchingLink || this.navigationLinks[0];

        this.navigationLinks.forEach((link) => {
          const isActive = link === activeLink;

          link.classList.toggle('is-active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }
    }
  );
}
